import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './quasar'
import axios from 'axios'
import { i18n } from './i18n'

Vue.config.productionTip = false
// axios.defaults.baseURL = "https://localhost:44380/api/" 
axios.defaults.baseURL = "https://api-mongo-autoconta.contago.com.mx/api/"

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

